import { CommonModule } from "@angular/common";
import { Component, computed, inject, input } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { EFloorType, EPropertyFeatures, EPropertyType } from "@app/shared/swap-request/enums/swap-request.enum";
import { homeFeatures as features } from "@app/shared/swap-request/static-data/home-features.constant";
import { TranslateModule } from "@ngx-translate/core";
import { ISwapRequestEntity } from "@app/shared/swap-request/interfaces/swap-request.interface";
import {
  formatAddressKey,
  generateSpecificTags,
  getFloorTypeTranslationKey,
  getPropertyTypeTranslationKey,
  getRelativeTimeKey,
  mapFeaturesKeys,
} from "@app/shared/swap-request/helpers/property.helper";
import { ResourcePipe } from "@kernel/tools/download-files/pipes/resource.pipe";

export type HomeFeature = {
  id: EPropertyFeatures;
  label: string;
  emoji: string;
};

export const homeFeatures: HomeFeature[] = features;

@Component({
  selector: "app-chat-property",
  imports: [CommonModule, TranslateModule, ResourcePipe, RouterLink],
  templateUrl: "./chat-property.component.html",
  styleUrl: "./chat-property.component.scss",
})
export class ChatPropertyComponent {
  router = inject(Router);

  swapRequest = input<ISwapRequestEntity>();
  property = computed(() => {
    return this.swapRequest()?.property;
  });
  details = computed(() => {
    const swapReq = this.swapRequest();
    if (!swapReq?.property) return null;
    const property = swapReq.property;

    return {
      tags: generateSpecificTags(swapReq),
      title: getPropertyTypeTranslationKey(property.propertyType as EPropertyType),
      address: formatAddressKey(property.address),
      rooms: property.numberOfRooms,
      size: property.livingSpace,
      floor: getFloorTypeTranslationKey(property.floorType as EFloorType),
      rent: property.monthlyRent,
      updatedTime: getRelativeTimeKey(swapReq.updatedAt),
      activeDate: swapReq.activeDate,
    };
  });
  mappedFeatures = computed(() => mapFeaturesKeys(this.property()?.features ?? []));
}
